import { createContext, useContext } from 'react';
import { isNil } from 'lodash';
import { Logger } from 'utilities';
import { AuthSessionRestoreContextValue } from './AuthSessionRestoreContext.types';

const AUTH_SESSION_RESTORE_CONTEXT_ERROR =
  'useAuthSessionRestoreContext must be used within an AuthSessionRestoreProvider';

const AuthSessionRestoreContext = createContext<AuthSessionRestoreContextValue | null>(null);
AuthSessionRestoreContext.displayName = 'AuthSessionRestoreContext';

export const useAuthSessionRestoreContext = (): AuthSessionRestoreContextValue => {
  const context = useContext(AuthSessionRestoreContext);

  if (isNil(context)) {
    Logger.error(AUTH_SESSION_RESTORE_CONTEXT_ERROR, null);
    throw new Error(AUTH_SESSION_RESTORE_CONTEXT_ERROR);
  }

  return context;
};

export default AuthSessionRestoreContext;
